import { GraphQLClient } from 'graphql-request';

let shopClient;
export const getShopifyClient = () => {
  if (shopClient) return shopClient;

  shopClient = new GraphQLClient(
    `https://${process.env.GATSBY_SHOPIFY_DOMAIN_NAME}/api/${process.env.GATSBY_SHOPIFY_API_VERSION}/graphql.json`,
    {
      headers: {
        'X-Shopify-Storefront-Access-Token':
          process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
      },
    }
  );
  return shopClient;
};

export const makeShopifyRequest = (query, { id }, customShopifyClient) => {
  const shopifyClient = customShopifyClient || getShopifyClient();
  return shopifyClient.request(query, {
    id,
  });
};

export const FETCH_PRODUCT_UPDATE_QUERY = `
  query ProductUpdateQuery($id: ID!) {
    product(id: $id) {
      sellingPlanGroups(first: 1) {
        nodes {
          sellingPlans(first: 7) {
            nodes {
              id
              name
            }
          }
        }
      }
      variants(first: 100) {
        nodes {
          id
          sku
          availableForSale
          quantityAvailable
          sellingPlanAllocations(first: 7) {
            nodes {
              priceAdjustments {
                price {
                  amount
                }
              }
              sellingPlan {
                name
                id
                priceAdjustments {
                  adjustmentValue {
                    ... on SellingPlanPercentagePriceAdjustment {
                      __typename
                      adjustmentPercentage
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ADDON_QUERY = `
  query ProductAddOnQuery($id: ID!) {
    product(id: $id) {
      variants(first: 100) {
        nodes {
          sku
          availableForSale
          quantityAvailable
        }
      }
    }
  }
`;
